<template>
  <div class="body_2">
    <center>
      <div class="body_1">
        <self-header
          :bg_color="header_color"
          :hd_position="header_position"
          :hover_flag="header_hover"
        ></self-header>
        <self-logo></self-logo>
        <self-daohang></self-daohang>
        <self-nav3></self-nav3>
        <router-view></router-view>
        <self-footer :baseUrl="baseUrl"></self-footer>
        <div class="backtop" @click="backTop" v-show="show_backtop">
          <i class="el-icon-arrow-up"></i>
        </div>
      </div>
    </center>
  </div>
</template>

<script>
import selfHeader from "../components/Header";
import selfLogo from "../components/Logo";
import selfDaohang from "../components/Daohang";
import selfNav3 from "../components/Nav3";
import selfFooter from "../components/Footer";
import selfLoading from "../components/loading";
import { mapMutations } from "vuex";
import { mapState } from "vuex";
export default {
  components: {
    selfHeader,
    selfLogo,
    selfDaohang,
    selfNav3,
    selfFooter,
    selfLoading
  },
  data() {
    return {
      header_color: "", // header背景色
      header_position: "", // header定位
      header_hover: "", // header图标是否显示白光划过效果
      show_backtop: false // 是否显示回到顶部按钮
    };
  },
  computed: {
    ...mapState({
      baseUrl: state => state.global.baseUrl
    })
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    this.setBaseUrl('')
  },
  methods: {
    ...mapMutations(['setBaseUrl']),
    handleScroll() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (scrollTop === 0) this.header_color = "transparent";
      if (scrollTop > 100) this.header_color = "rgba(3,3,3,.8)";
      if (scrollTop > 200) this.show_backtop = true;
      if (scrollTop < 200) this.show_backtop = false;
    },
    backTop() {
      // 让回到顶部更加平滑
      let scrollTop;
      var time = setInterval(() => {
        scrollTop =
          window.pageYOffset ||
          document.documentElement.scrollTop ||
          document.body.scrollTop;
        window.scroll(0, scrollTop - 50);
        if (scrollTop === 0) clearInterval(time);
      }, 50);
    },
    head_fix(val) {
      this.header_position = val[0];
      this.header_hover = val[1];
    }
  }
};
</script>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/views/Main.vue